import { computed } from 'mobx';
import { ROLE } from '@link/share/constants';
import { BaseAuth } from '@link/share/stores';

export class Auth extends BaseAuth {
  @computed
  get email(): string {
    return this.user?.email || '';
  }

  @computed
  get isAdmin(): boolean {
    return this.claims?.SUPPLIER_SERVICE?.role === ROLE.ADMIN;
  }

  @computed
  get isEditor(): boolean {
    return this.claims?.SUPPLIER_SERVICE?.role === ROLE.EDITOR;
  }

  @computed
  get isOperator(): boolean {
    return this.claims?.SUPPLIER_SERVICE?.role === ROLE.OPERATOR;
  }

  @computed
  get isViewer(): boolean {
    return this.claims?.SUPPLIER_SERVICE?.role === ROLE.VIEWER;
  }

  @computed
  get isUnauthorizedUser(): boolean {
    return !this.claims?.SUPPLIER_SERVICE;
  }

  @computed
  get userSupplierId(): string {
    return this.claims?.SUPPLIER_SERVICE?.['supplier-id'] || '';
  }
}
export default new Auth();
